import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import PropTypes from 'prop-types'

// Components
import PageInfo from '../../pageinfo/PageInfo'
import NREOverview from '../../nreoverview/NREOverview'
import NewsElement from './newselement/NewsElement'
import NewsDetails from './newsdetails/NewsDetails'

class News extends Component {

    static propTypes = {
        news: PropTypes.array.isRequired
    }

    render() {
        return (
            <div>
                <PageInfo
                    title={'News'}
                    description={"Marjolein Varekamp's latest news"}
                />

                <Switch>
                    <Route exact path='/news' render={
                        () => <NREOverview>
                            {this.props.news.map(newsItem => {
                                return (
                                    <NewsElement key={newsItem.url} news={newsItem} />
                                )
                            })}
                        </NREOverview>
                    } />
                    <Route path='/news/:string' component={NewsDetails} />
                </Switch>
            </div>
        )
    }
}

export default News;





// WEBPACK FOOTER //
// ./src/components/main/news/News.js